/* Presentation and documented app entry points only. Apps own reviews, signups and email delivery. */
(() => {
  const labels = document.getElementById('apo-app-labels');
  const notifyLabel = labels?.dataset.restockNotify;
  let reviewPageRequested = false;

  function adaptRestockButton(root) {
    const buttons = root.matches?.('.restock-rocket-button-product') ? [root] : root.querySelectorAll?.('.restock-rocket-button-product') || [];
    for (const button of buttons) {
      if (notifyLabel && button.textContent !== notifyLabel) button.textContent = notifyLabel;
    }
  }
  adaptRestockButton(document);
  function adaptReviewDialog(root) {
    const closeSelector = '.jdgm-write-review-modal__close-btn';
    const buttons = root.matches?.(closeSelector) ? [root] : root.querySelectorAll?.(closeSelector) || [];
    for (const button of buttons) {
      // The app hides this button after step one. Keep the visible close control keyboard-accessible.
      if (button.getAttribute('aria-hidden') === 'true') button.removeAttribute('aria-hidden');
      if (button.getAttribute('tabindex') === '-1') button.removeAttribute('tabindex');
      if (document.documentElement.lang.startsWith('fr')) button.setAttribute('aria-label', 'Fermer le formulaire d’avis');
    }
  }
  adaptReviewDialog(document);
  // STOQ inserts its button asynchronously and replaces it when a variant changes.
  new MutationObserver(records => {
    for (const record of records) {
      // Horizon scrolls inside its page wrapper; keep new review pages in view there too.
      if (reviewPageRequested && record.type === 'attributes' && record.attributeName === 'aria-current'
        && record.target.matches('.apo-reviews .jm-pagination-controls__button[aria-current="page"]')) {
        reviewPageRequested = false;
        document.getElementById('avis-clients')?.scrollIntoView({
          block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
      if (record.type === 'attributes') adaptReviewDialog(record.target);
      for (const node of record.addedNodes) if (node.nodeType === Node.ELEMENT_NODE) {
        adaptRestockButton(node);
        adaptReviewDialog(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'tabindex', 'aria-current'] });

  document.addEventListener('click', event => {
    if (event.target.closest?.('.apo-reviews .jm-pagination-controls__button:not(:disabled):not([aria-current="page"])')) reviewPageRequested = true;
  }, true);

  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-apo-restock]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const app = window._RestockRocket;
    if (!app?.openModal) return; // Navigate to the native product-page alert if the app is still loading.
    const data = link.closest('.apo-restock')?.querySelector('[data-apo-restock-product]');
    if (!data) return;
    try {
      const product = JSON.parse(data.textContent);
      app.openModal(product, link.dataset.variantId);
      event.preventDefault();
    } catch {
      // Preserve the link rather than trapping the customer in a failed app interaction.
    }
  });
})();
